import { jsx as _jsx } from "react/jsx-runtime";
import Chart from 'react-apexcharts';
function AreaChart(_a) {
    var categories = _a.categories, colors = _a.colors, series = _a.series;
    var options = {
        chart: {
            toolbar: { show: false },
            zoom: { enabled: false },
            fontFamily: "'Gabarito', sans-serif",
            width: undefined
        },
        markers: {
            size: 4
        },
        stroke: {
            curve: 'smooth',
            colors: colors,
            width: 2
        },
        dataLabels: { enabled: false },
        colors: colors,
        xaxis: {
            type: 'category',
            categories: categories,
            labels: {
                style: {
                    fontFamily: "'Gabarito', sans-serif",
                    fontSize: '11px'
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    fontFamily: "'Gabarito', sans-serif"
                },
            },
            forceNiceScale: true
        },
        legend: {
            show: true,
            horizontalAlign: 'left',
            offsetY: 10,
            fontSize: '12px',
            fontWeight: '500'
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function (val) {
                    return "".concat(val, " token").concat(val !== 1 ? 's' : '', " ativos");
                }
            }
        }
    };
    return (_jsx(Chart, { options: options, series: series, type: "line", height: 255 }));
}
export default AreaChart;
